import React from "react";
import Moment from "react-moment";
import { getFromStore, STORE_KEYS } from "../../storage/Storage";
import CustomTooltip from "../Interface/Tooltip";
import Day from "./Day";

type DateFromProps = {
  children: React.ReactNode;
  add?: Record<string, number>;
  title?: string | null;
};

const DateFrom: React.FC<DateFromProps> = ({ children, add, title = null }) => {
  if (!children) {
    return null;
  }
  const locale = getFromStore(STORE_KEYS.LANGUAGE) || "en";

  return (
    <>
      <CustomTooltip placement="top" title={<Day withHours>{children}</Day>}>
        <div>
          {title && title + ": "}
          <Moment fromNow add={add} locale={locale}>
            {children as string | number}
          </Moment>
        </div>
      </CustomTooltip>
    </>
  );
};

export default DateFrom;
